// src/app/stores/orderStore.ts
import { makeAutoObservable, runInAction } from "mobx";
import { getOrders } from "../services/OrderService";
import { toast } from "react-toastify";

export interface Order {
  id: number;
  unique_id: string;
  created_at: string;
  total_amount: string;
  items: { product_id: number; quantity: number }[];
  invoice_number?: string;
  statusHistory: {
    status: {
      name: "ORDERED" | "DELIVERED" | "PROCESSING";
    };
  }[];
  outlet:{
     id: string,
     name: string,            
  }
}

export default class OrderStore {
  orders: Order[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  loadOrders = async () => {
    try {
      const res = (await getOrders({})) as {
        status: string;
        data: any[];
        message: string;
      };
      if (res && res.status === "success") {
        runInAction(() => {
          this.orders = res.data;
        });
      }
    } catch (error) {
      toast.error("Could not load cart items");
    }
  };
}
